<template>
    <div class="strawberry-container">
        <div class="operation-bar">
            <el-button type="primary" size="mini" @click="handleCreate">+新增</el-button>
            <el-button type="danger" size="mini" @click="handleBatchDelete"
                :disabled="!selectedRows.length">删除</el-button>
            <div class="search-box">
                <el-select v-model="searchStatus" placeholder="状态" style="width: 200px;" size="mini" clearable>
                    <el-option label="启用" value="启用"></el-option>
                    <el-option label="禁用" value="禁用"></el-option>
                </el-select>
                <el-button icon="el-icon-search" style="margin-left: 10px;" size="mini" type="primary"
                    @click="handleSearch">查询</el-button>
            </div>
        </div>

        <el-table :data="tableData" border style="width: 100%" height="60vh" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="序号" type="index" width="80" align="center">
            </el-table-column>
            <el-table-column prop="serialNumber" label="大棚编号"></el-table-column>
            <el-table-column prop="updateTime" label="更新时间"></el-table-column>
            <el-table-column prop="enabled" label="启用">
                <template slot-scope="scope">
                    <el-tag :type="scope.row.enabled === 1 ? 'success' : 'info'">{{ scope.row.enabled === 1 ? '启用' :
                        '禁用' }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                    <el-button type="text" style="color: #2680DD;" @click="handleEdit(scope.row)">编辑</el-button>
                    <el-button type="text" style="color: #04FF9F;" @click="handleView(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </div>

        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" @close="handleDialogClose">
            <el-form :model="formData" :rules="rules" ref="formRef" label-width="140px">
                <el-form-item label="大棚编号" prop="serialNumber">
                    <el-input :disabled="isView" v-model="formData.serialNumber" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="绑定大棚管理员" prop="boundAdminIds">
                    <el-select :disabled="isView" v-model="formData.boundAdminIds" multiple placeholder="请选择"
                        style="width: 100%" :filterable="true">
                        <el-option v-for="item in managerOptions" :key="item.id" :label="item.nickName"
                            :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="绑定农技员" prop="boundTechnicianIds">
                    <el-select :disabled="isView" v-model="formData.boundTechnicianIds" multiple placeholder="请选择"
                        style="width: 100%" :filterable="true">
                        <el-option v-for="item in technicianOptions" :key="item.id" :label="item.nickName"
                            :value="item.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="大棚预计产量(kg)" prop="estimatedOutput">
                    <el-input :disabled="isView" v-model="formData.estimatedOutput" placeholder="请输入预计产量" type="number" min="0"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="enabled">
                    <el-switch :disabled="isView" v-model="formData.enabled" :active-value="1" :inactive-value="0">
                    </el-switch>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" v-if="!isView" @click="handleSubmit">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from '@/axios'
import { baseUrl } from '@/axios/baseUrl'

export default {
    name: 'GreenhouseManagement',
    data() {
        return {
            tableData: [],
            selectedRows: [],
            searchStatus: '',
            page: 1,
            pageSize: 10,
            totalCount: 0,
            dialogVisible: false,
            dialogTitle: '新增',
            managerOptions: [], // 大棚管理员选项
            technicianOptions: [], // 农技员选项
            formData: {
                id: '',
                serialNumber: '',
                boundAdminIds: [],
                boundTechnicianIds: [],
                estimatedOutput: '',
                enabled: 1
            },
            isEdit: false,
            isView: false, // 新增：用于控制弹窗是否为只读
            rules: {
                serialNumber: [
                    { required: true, message: '请输入大棚编号', trigger: 'blur' }
                ],
                boundAdminIds: [
                    { required: true, type: 'array', min: 1, message: '请选择大棚管理员', trigger: 'change' }
                ],
                boundTechnicianIds: [
                    { required: true, type: 'array', min: 1, message: '请选择农技员', trigger: 'change' }
                ]
            }
        }
    },
    created() {
        this.fetchData()
    },
    methods: {
        // 获取数据
        async fetchData() {
            try {
                const params = {
                    page: this.page,
                    pageSize: this.pageSize,
                    enabled: this.searchStatus === '启用' ? 1 : this.searchStatus === '禁用' ? 0 : undefined,
                }
                const res = await axios.post(baseUrl + '/api/basic/greenhouse/list-page', params)
                if (res.code === 200) {
                    this.tableData = res.data.list || []
                    this.totalCount = parseInt(res.data.totalCount) || 0
                }
            } catch (error) {
                console.error('获取大棚列表失败:', error)
            }
        },

        // 获取管理员和农技员列表
        async fetchUserList() {
            try {
                const res = await axios.post(baseUrl + '/api/system/user/page', {
                    page: 1,
                    pageSize: 288,
                })
                if (res.code === 200) {
                    const users = res.data.list || []
                    console.log('获取的用户', users);

                    this.managerOptions = users.filter(user => user.roleCodes && user.roleCodes.split(',').includes('greenhouse_admin'))
                    this.technicianOptions = users.filter(user => user.roleCodes && user.roleCodes.split(',').includes('agronomist'))
                }
            } catch (error) {
                console.error('获取用户列表失败:', error)
            }
        },

        // 选择行变化
        handleSelectionChange(selection) {
            this.selectedRows = selection
        },

        // 搜索
        handleSearch() {
            this.page = 1
            this.fetchData()
        },

        // 新增大棚
        handleCreate() {
            this.isEdit = false
            this.dialogTitle = '新增'
            this.dialogVisible = true
            this.fetchUserList()
            this.$nextTick(() => {
                this.$refs.formRef && this.$refs.formRef.resetFields()
                this.formData = {
                    id: '',
                    serialNumber: '',
                    boundAdminIds: [],
                    boundTechnicianIds: [],
                    estimatedOutput: '',
                    enabled: 1
                }
            })
        },

        // 编辑大棚
        handleEdit(row) {
            this.isEdit = true
            this.dialogTitle = '编辑'
            this.dialogVisible = true
            this.fetchUserList()
            this.$nextTick(() => {
                this.$refs.formRef && this.$refs.formRef.resetFields()
                this.formData = {
                    id: row.id,
                    serialNumber: row.serialNumber,
                    boundAdminIds: (row.boundAdmins || []).map(u => u.id),
                    boundTechnicianIds: (row.boundTechnicians || []).map(u => u.id),
                    estimatedOutput: row.estimatedOutput || '',
                    enabled: row.enabled
                }
            })
        },

        // 查看大棚（只读弹窗）
        handleView(row) {
            this.dialogTitle = '查看';
            this.dialogVisible = true;
            this.fetchUserList();
            this.$nextTick(() => {
                this.$refs.formRef && this.$refs.formRef.resetFields();
                this.formData = {
                    id: row.id,
                    serialNumber: row.serialNumber,
                    boundAdminIds: (row.boundAdmins || []).map(u => u.id),
                    boundTechnicianIds: (row.boundTechnicians || []).map(u => u.id),
                    estimatedOutput: row.estimatedOutput || '',
                    enabled: row.enabled
                };
            });
            // 可选：设置只读状态
            this.isView = true;
        },

        // 关闭弹窗
        handleDialogClose() {
            this.$refs.formRef && this.$refs.formRef.resetFields()
            this.isEdit = false
            this.isView = false
            this.formData = {
                id: '',
                serialNumber: '',
                boundAdminIds: [],
                boundTechnicianIds: [],
                estimatedOutput: '',
                enabled: 1
            }
        },

        // 提交表单
        handleSubmit() {
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    try {
                        const url = this.isEdit ? '/api/basic/greenhouse/edit' : '/api/basic/greenhouse/add'
                        const submitData = {
                            ...this.formData,
                            boundAdmins: this.formData.boundAdminIds.map(id => {
                                const user = this.managerOptions.find(u => u.id === id)
                                return { id, name: user ? user.nickName : '' }
                            }),
                            boundTechnicians: this.formData.boundTechnicianIds.map(id => {
                                const user = this.technicianOptions.find(u => u.id === id)
                                return { id, name: user ? user.nickName : '' }
                            })
                        }
                        delete submitData.boundAdminIds
                        delete submitData.boundTechnicianIds
                        const res = await axios.post(baseUrl + url, submitData)
                        if (res.code === 200) {
                            this.$message.success(this.isEdit ? '更新成功' : '新增成功')
                            this.dialogVisible = false
                            this.fetchData()
                            this.$store.dispatch('farm/getGreenhouseOptions')
                        }
                    } catch (error) {
                        console.error(this.isEdit ? '更新大棚失败:' : '新增大棚失败:', error)
                    }
                }
            })
        },

        // 删除大棚
        async handleDelete(row) {
            try {
                await this.$confirm('确认删除该大棚吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                const res = await axios.post(baseUrl + '/api/basic/greenhouse/delete-batch', [row.id])
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.fetchData()
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除大棚失败:', error)
                }
            }
        },

        // 批量删除
        async handleBatchDelete() {
            if (!this.selectedRows.length) return
            try {
                await this.$confirm(`确认删除选中的 ${this.selectedRows.length} 个大棚吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                const ids = this.selectedRows.map(row => row.id)
                const res = await axios.post(baseUrl + '/api/basic/greenhouse/delete-batch', ids)
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.fetchData()
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('批量删除大棚失败:', error)
                }
            }
        },

        // 分页大小变化
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchData()
        },

        // 页码变化
        handleCurrentChange(val) {
            this.page = val
            this.fetchData()
        }
    }
}
</script>

<style scoped lang="less">
.strawberry-container {
    padding: 20px;

    .operation-bar {
        margin-bottom: 20px;
        display: flex;
        align-items: center;

        .search-box {
            margin-left: auto;
        }
    }

    .delete-button {
        color: #F56C6C;
    }

    .pagination-container {
        margin-top: 20px;
        text-align: right;
    }
}
</style>